module.exports = __webpack_public_path__ + "static/media/loadera08b57a0.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/practice_admin/images/loader.gif
// module id = 84
// module chunks = 0